package com.dotdrives.web.pages.marketing

import react.FC
import react.Props
import react.dom.html.ReactHTML.style

private val marketingStyles = """
    .marketing-page { background: #FFFDFA; color: #222D32; }
    .marketing-eyebrow {
      font-family: 'IBM Plex Mono', monospace; font-size: 13px; letter-spacing: 2px;
      color: #F26223; margin-bottom: 14px;
    }
    .marketing-eyebrow-inverted { color: #F79E78; }
    .marketing-eyebrow-muted { color: #88949C; text-align: center; }
    .marketing-eyebrow-center { text-align: center; }
    .marketing-section-title { font-family: 'Quicksand', sans-serif; font-size: 42px; font-weight: 700; line-height: 1.15; margin: 0 0 18px; }
    .marketing-section-title-sm { font-size: 38px; }
    .marketing-section-copy { font-size: 17px; color: #5A6870; line-height: 1.7; margin: 0 0 22px; }
    .marketing-section-copy-tight { margin-bottom: 0; }
    .marketing-process-point-bold { font-weight: 800; }

    /* nav */
    .marketing-nav {
      position: sticky; top: 0; z-index: 40; display: flex; align-items: center; justify-content: space-between;
      padding: 20px 64px; border-bottom: 1px solid #F0EBE4; background: #FFFDFA;
    }
    .marketing-nav-brand { display: flex; align-items: center; gap: 7px; color: #222D32; font-family: 'Quicksand', sans-serif; font-size: 19px; font-weight: 700; letter-spacing: -.4px; }
    .marketing-nav-brand-mark { color: #F26223; letter-spacing: -3px; }
    .marketing-nav-links { display: flex; align-items: center; gap: 36px; font-size: 15px; font-weight: 700; color: #3D4A52; }
    .marketing-nav-full-actions { display: flex; align-items: center; gap: 14px; }
    .marketing-nav-signin {
      padding: 0; border: 0; color: #3D4A52; background: transparent; cursor: pointer;
      font-family: inherit; font-size: 15px; font-weight: 700;
    }
    .marketing-nav-cta.dot-button-primary { padding: 11px 22px; font-size: 15px; }
    .marketing-nav-compact { display: none; align-items: center; gap: 10px; }
    .marketing-nav-compact .marketing-nav-signin { min-height: 44px; white-space: nowrap; }

    /* hero */
    .marketing-hero { padding: 84px 64px 40px; text-align: center; position: relative; overflow: hidden; }
    .marketing-hero-eyebrow { text-align: center; }
    .marketing-hero-title { font-family: 'Quicksand', sans-serif; font-size: 72px; font-weight: 700; line-height: 1.06; margin: 0 auto 22px; max-width: 900px; }
    .marketing-hero-accent { color: #F26223; }
    .marketing-hero-subcopy { font-size: 20px; color: #5A6870; line-height: 1.6; max-width: 620px; margin: 0 auto 32px; }
    .marketing-hero-subcopy-short { display: none; }
    .marketing-process-copy-short { display: none; }
    .marketing-hero-actions { display: flex; gap: 14px; justify-content: center; margin-bottom: 64px; }
    .marketing-hero-cta { padding: 15px 30px; font-size: 16px; }

    /* drive card */
    .marketing-drive-card { max-width: 1080px; margin: 0 auto; background: #222D32; border-radius: 20px; padding: 36px 40px 44px; text-align: left; position: relative; color: #fff; }
    .marketing-drive-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 26px; flex-wrap: wrap; gap: 6px; }
    .marketing-drive-name { font-family: 'Quicksand', sans-serif; font-size: 18px; font-weight: 700; color: #fff; }
    .marketing-drive-meta { font-family: 'IBM Plex Mono', monospace; font-size: 12px; color: #8FA0AA; }
    .marketing-drive-track { position: relative; height: 6px; background: rgba(255,255,255,.12); border-radius: 3px; margin: 0 20px; }
    .marketing-drive-dot {
      position: absolute; top: -7px; left: 8%; width: 20px; height: 20px; border-radius: 50%;
      background: #F26223; border: 4px solid #222D32; box-shadow: 0 0 20px rgba(242,98,35,.8);
    }
    .marketing-phase-grid { display: grid; grid-template-columns: repeat(5, 1fr); margin-top: 18px; }
    .marketing-phase { text-align: center; }
    .marketing-phase-name { font-family: 'Quicksand', sans-serif; font-weight: 700; font-size: 16px; color: #fff; }
    .marketing-phase-hint { font-size: 12.5px; color: #8FA0AA; margin-top: 2px; }

    /* trust strip */
    .marketing-trust { padding: 28px 64px 20px; border-bottom: 1px solid #F0EBE4; }
    .marketing-trust-row { display: flex; flex-wrap: wrap; gap: 32px 56px; justify-content: center; align-items: center; }
    .marketing-trust-logo { font-family: 'Quicksand', sans-serif; font-weight: 700; font-size: 19px; color: #B4BCC2; white-space: nowrap; }

    /* process + kanban */
    .marketing-process { padding: 88px 64px; display: grid; grid-template-columns: 440px 1fr; gap: 64px; align-items: center; }
    .marketing-process-points { display: flex; flex-direction: column; gap: 12px; }
    .marketing-process-point { display: flex; gap: 12px; align-items: flex-start; }
    .marketing-process-check {
      width: 22px; height: 22px; border-radius: 50%; background: #E3F1E8; color: #007942; font-weight: 900;
      font-size: 13px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; margin-top: 1px;
    }
    .marketing-process-text { font-size: 15.5px; color: #3D4A52; line-height: 1.5; }
    .marketing-kanban { background: #ECF0F5; border-radius: 18px; padding: 26px; position: relative; }
    .marketing-kanban-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px; }
    .marketing-kanban-col { background: #fff; border-radius: 12px; padding: 14px; min-height: 250px; }
    .marketing-kanban-col-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
    .marketing-kanban-col-name { font-family: 'Quicksand', sans-serif; font-weight: 700; font-size: 14px; }
    .marketing-kanban-col-count { font-family: 'IBM Plex Mono', monospace; font-size: 11px; color: #88949C; }
    .marketing-kanban-card { border: 1px solid #E4E8EC; border-left: 4px solid; border-radius: 8px; padding: 10px 12px; margin-bottom: 10px; background: #fff; }
    .marketing-kanban-card-name { font-weight: 800; font-size: 13px; }
    .marketing-kanban-card-sub { font-size: 11.5px; color: #88949C; }
    .marketing-kanban-float {
      position: absolute; left: 44px; bottom: 48px; width: 150px; background: #fff; border: 1px solid #F26223;
      border-left: 4px solid #F26223; border-radius: 8px; padding: 10px 12px; box-shadow: 0 10px 26px rgba(242,98,35,.25);
    }

    /* features */
    .marketing-features { background: #222D32; padding: 88px 64px; }
    .marketing-features-head { text-align: center; margin-bottom: 52px; }
    .marketing-features-title { font-family: 'Quicksand', sans-serif; font-size: 42px; font-weight: 700; color: #fff; margin: 0; }
    .marketing-features-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 18px; max-width: 1180px; margin: 0 auto; }
    .marketing-feature-card {
      background: rgba(255,255,255,.05); border: 1px solid rgba(255,255,255,.09); border-radius: 16px; padding: 26px;
      transition: background-color .25s ease, transform .25s ease;
    }
    .marketing-feature-card:hover { background: rgba(255,255,255,.09); transform: translateY(-4px); }
    .marketing-feature-icon { width: 44px; height: 44px; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 20px; margin-bottom: 16px; }
    .marketing-feature-name { font-family: 'Quicksand', sans-serif; font-weight: 700; font-size: 19px; color: #fff; margin-bottom: 8px; }
    .marketing-feature-detail { font-size: 14.5px; color: #AEBBC3; line-height: 1.6; }

    /* giving forms + feed */
    .marketing-forms { padding: 72px 64px; display: grid; grid-template-columns: 1fr 1fr; gap: 64px; align-items: center; border-bottom: 1px solid #F0EBE4; }
    .marketing-feed-panel { background: #FFFDFA; border: 1px solid #EDE7DF; border-radius: 18px; padding: 24px 28px; box-shadow: 0 16px 44px rgba(34,45,50,.08); }
    .marketing-feed-label { font-family: 'IBM Plex Mono', monospace; font-size: 12px; color: #88949C; margin-bottom: 14px; }
    .marketing-feed-list { display: flex; flex-direction: column; }
    .marketing-feed-row { display: flex; justify-content: space-between; align-items: center; height: 44px; }
    .marketing-feed-person { display: flex; gap: 12px; align-items: center; }
    .marketing-feed-avatar { width: 32px; height: 32px; border-radius: 50%; color: #fff; font-weight: 800; font-size: 13px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
    .marketing-feed-name { font-weight: 800; font-size: 14px; }
    .marketing-feed-form { font-size: 12px; color: #88949C; }
    .marketing-feed-amount { text-align: right; }
    .marketing-feed-amt { font-weight: 900; font-size: 15px; color: #00A65A; }
    .marketing-feed-when { font-size: 11px; color: #B4BCC2; font-family: 'IBM Plex Mono', monospace; }
    .marketing-feed-footer { margin-top: 14px; border-top: 1px dashed #E4E8EC; padding-top: 12px; display: flex; justify-content: space-between; align-items: center; }
    .marketing-feed-synced { font-size: 13px; color: #5A6870; font-weight: 700; }
    .marketing-feed-badge { font-size: 12px; padding: 4px 10px; }

    /* a day with dot drives */
    .marketing-day { background: #F4F1EB; padding: 88px 64px; }
    .marketing-day-head { text-align: center; margin-bottom: 52px; }
    .marketing-day-title { font-family: 'Quicksand', sans-serif; font-size: 42px; font-weight: 700; margin: 0; }
    .marketing-day-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; max-width: 1180px; margin: 0 auto; }
    .marketing-day-card { background: #fff; border-radius: 18px; padding: 26px; box-shadow: 0 6px 24px rgba(34,45,50,.06); transition: transform .25s ease, box-shadow .25s ease; }
    .marketing-day-card:hover { transform: translateY(-4px); box-shadow: 0 16px 40px rgba(34,45,50,.12); }
    .marketing-day-time { font-family: 'IBM Plex Mono', monospace; font-size: 11px; letter-spacing: 2px; color: #88949C; margin-bottom: 14px; }
    .marketing-day-mini { border: 1px solid #E4E8EC; border-radius: 12px; padding: 13px 15px; margin-bottom: 18px; }
    .marketing-day-mini-head { display: flex; align-items: center; gap: 9px; margin-bottom: 4px; }
    .marketing-day-mini-icon { font-size: 15px; }
    .marketing-day-mini-title { font-weight: 800; font-size: 13px; }
    .marketing-day-mini-body { font-size: 12px; color: #5A6870; line-height: 1.5; }
    .marketing-day-card-title { font-family: 'Quicksand', sans-serif; font-weight: 700; font-size: 20px; margin-bottom: 8px; }
    .marketing-day-card-body { font-size: 14.5px; color: #5A6870; line-height: 1.65; }

    /* roles */
    .marketing-roles { padding: 88px 64px; display: grid; grid-template-columns: 1fr 480px; gap: 64px; align-items: center; border-bottom: 1px solid #F0EBE4; }
    .marketing-role-list { display: flex; flex-direction: column; gap: 12px; }
    .marketing-role-row { display: flex; gap: 14px; align-items: center; background: #FFFDFA; border: 1px solid #F0EBE4; border-radius: 14px; padding: 14px 18px; }
    .marketing-role-icon { width: 40px; height: 40px; border-radius: 11px; display: flex; align-items: center; justify-content: center; font-size: 18px; flex-shrink: 0; }
    .marketing-role-copy { flex: 1; min-width: 0; }
    .marketing-role-name { font-weight: 800; font-size: 15px; }
    .marketing-role-desc { font-size: 13px; color: #5A6870; }
    .marketing-role-chip { font-size: 11px; }
    .marketing-joseph { background: #222D32; border-radius: 20px; padding: 30px 32px; color: #fff; }
    .marketing-joseph-label { font-family: 'IBM Plex Mono', monospace; font-size: 11px; letter-spacing: 2px; color: #8FA0AA; margin-bottom: 18px; }
    .marketing-joseph-card { background: rgba(255,255,255,.06); border-radius: 14px; padding: 16px 18px; margin-bottom: 12px; }
    .marketing-joseph-card-locked { opacity: .45; margin-bottom: 0; }
    .marketing-joseph-card-title { font-weight: 800; font-size: 14px; margin-bottom: 4px; }
    .marketing-joseph-card-body { font-size: 12.5px; color: #AEBBC3; }
    .marketing-joseph-footer { margin-top: 18px; font-size: 12.5px; color: #8FA0AA; }

    /* stats + testimonials */
    .marketing-social { padding: 88px 64px; text-align: center; }
    .marketing-stats-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 18px; max-width: 1080px; margin: 0 auto 64px; }
    .marketing-stat-value { font-family: 'Quicksand', sans-serif; font-size: 44px; font-weight: 700; color: #F26223; }
    .marketing-stat-label { font-size: 14px; color: #5A6870; font-weight: 700; }
    .marketing-quotes-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; max-width: 1180px; margin: 0 auto; }
    .marketing-quote-card { background: #FFFDFA; border: 1px solid #F0EBE4; border-radius: 18px; padding: 28px; text-align: left; display: flex; flex-direction: column; }
    .marketing-quote-stars { color: #F26223; font-size: 22px; letter-spacing: 2px; margin-bottom: 12px; }
    .marketing-quote-text { font-size: 15.5px; color: #3D4A52; line-height: 1.7; flex: 1; }
    .marketing-quote-short { display: none; }
    .marketing-quote-footer { display: flex; gap: 12px; align-items: center; margin-top: 20px; }
    .marketing-quote-avatar { width: 40px; height: 40px; border-radius: 50%; color: #fff; font-weight: 800; font-size: 14px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
    .marketing-quote-name { font-weight: 800; font-size: 14px; }
    .marketing-quote-role { font-size: 12px; color: #88949C; }

    /* pricing */
    .marketing-pricing { background: #F4F1EB; padding: 88px 64px; text-align: center; }
    .marketing-pricing-title { font-family: 'Quicksand', sans-serif; font-size: 42px; font-weight: 700; margin: 0 0 44px; }
    .marketing-pricing-grid { display: flex; gap: 22px; justify-content: center; align-items: stretch; flex-wrap: wrap; }
    .marketing-plan { width: 340px; text-align: left; border: 1px solid #E9E2D8; border-radius: 20px; padding: 32px; }
    .marketing-plan-name { font-family: 'Quicksand', sans-serif; font-weight: 700; font-size: 22px; }
    .marketing-plan-price-row { margin: 14px 0 4px; }
    .marketing-plan-price { font-family: 'Quicksand', sans-serif; font-size: 44px; font-weight: 700; }
    .marketing-plan-per { font-size: 15px; opacity: .65; }
    .marketing-plan-sub { font-size: 14px; opacity: .75; margin-bottom: 20px; }
    .marketing-plan-feats { display: flex; flex-direction: column; gap: 10px; margin-bottom: 26px; }
    .marketing-plan-feat { font-size: 14.5px; display: flex; gap: 9px; }
    .marketing-plan-feat-mark { color: #F26223; font-weight: 900; }
    .marketing-plan-cta.dot-button { width: 100%; text-align: center; padding: 13px; font-size: 15px; }
    .marketing-pricing-note { margin-top: 22px; font-size: 14px; color: #88949C; }
    .marketing-pricing-note-short { display: none; }

    /* faq */
    .marketing-faq { padding: 88px 64px; max-width: 820px; margin: 0 auto; }
    .marketing-faq-title { font-family: 'Quicksand', sans-serif; font-size: 36px; font-weight: 700; text-align: center; margin: 0 0 40px; }
    .marketing-faq-list { display: flex; flex-direction: column; gap: 12px; }
    .marketing-faq-item { border: 1px solid #F0EBE4; border-radius: 14px; padding: 20px 24px; background: #FFFDFA; transition: border-color .16s ease; }
    .marketing-faq-item:hover { border-color: #F26223; }
    .marketing-faq-row { display: flex; justify-content: space-between; align-items: center; gap: 16px; }
    .marketing-faq-question { font-weight: 800; font-size: 16px; }
    .marketing-faq-mark { color: #F26223; font-size: 18px; font-weight: 800; flex-shrink: 0; }
    .marketing-faq-answer { font-size: 14.5px; color: #5A6870; line-height: 1.65; margin-top: 10px; }

    /* closing cta */
    .marketing-cta { background: #F26223; padding: 80px 64px; text-align: center; position: relative; overflow: hidden; }
    .marketing-cta-title { font-family: 'Quicksand', sans-serif; font-size: 46px; font-weight: 700; color: #fff; margin: 0 0 14px; position: relative; }
    .marketing-cta-copy { font-size: 18px; color: #FDE5DA; margin: 0 0 30px; position: relative; }
    .marketing-cta-button { padding: 16px 36px; font-size: 17px; }

    /* footer */
    .marketing-footer { background: #222D32; color: #8FA0AA; padding: 40px 64px; display: flex; justify-content: space-between; align-items: center; gap: 20px; flex-wrap: wrap; font-size: 14px; }
    .marketing-footer-brand { display: flex; align-items: center; gap: 7px; color: #fff; font-family: 'Quicksand', sans-serif; font-size: 19px; font-weight: 700; letter-spacing: -.4px; }
    .marketing-footer-brand-mark { color: #F26223; letter-spacing: -3px; }
    .marketing-footer-links { display: flex; gap: 28px; flex-wrap: wrap; justify-content: center; }
    .marketing-footer-copyright { font-family: 'IBM Plex Mono', monospace; font-size: 12px; }

    @media (max-width: 760px) {
      .marketing-nav { padding: 16px 20px; }
      .marketing-nav-links, .marketing-nav-full-actions { display: none; }
      .marketing-nav-compact { display: flex; }
      .marketing-hero { padding: 44px 24px 30px; }
      .marketing-hero-title { font-size: 36px; line-height: 1.1; margin-bottom: 14px; }
      .marketing-hero-break { display: none; }
      .marketing-hero-subcopy { font-size: 15.5px; margin-bottom: 22px; }
      .marketing-hero-subcopy-full { display: none; }
      .marketing-hero-subcopy-short { display: block; }
      .marketing-hero-actions { flex-direction: column; margin-bottom: 28px; }
      .marketing-hero-cta { padding: 14px; }
      .marketing-drive-card { padding: 22px 18px 26px; border-radius: 16px; }
      .marketing-phase-hint { display: none; }
      .marketing-phase-name { font-size: 10.5px; color: #C9D3D9; }
      .marketing-trust { padding: 14px 20px; }
      .marketing-trust-row { gap: 18px 28px; }
      .marketing-process, .marketing-forms, .marketing-roles {
        grid-template-columns: 1fr; padding: 44px 24px; gap: 24px;
      }
      .marketing-section-title { font-size: 28px; }
      .marketing-process-copy-full { display: none; }
      .marketing-process-copy-short { display: block; }
      .marketing-features { padding: 44px 24px; }
      .marketing-features-title { font-size: 28px; }
      .marketing-features-grid { grid-template-columns: 1fr; gap: 12px; }
      .marketing-feature-card { display: flex; gap: 14px; align-items: flex-start; padding: 16px; }
      .marketing-feature-icon { margin-bottom: 0; }
      .marketing-day { padding: 44px 24px; }
      .marketing-day-title { font-size: 26px; }
      .marketing-day-grid { grid-template-columns: 1fr; }
      .marketing-social { padding: 44px 24px; }
      .marketing-stats-grid { grid-template-columns: 1fr 1fr; margin-bottom: 32px; }
      .marketing-quotes-grid { grid-template-columns: 1fr; }
      .marketing-quote-full { display: none; }
      .marketing-quote-short { display: block; }
      .marketing-quote-desktop-only { display: none; }
      .marketing-pricing { padding: 44px 24px; }
      .marketing-pricing-title { font-size: 28px; }
      .marketing-plan { width: 100%; }
      .marketing-pricing-note-full { display: none; }
      .marketing-pricing-note-short { display: block; }
      .marketing-faq { padding: 44px 24px; }
      .marketing-faq-title { font-size: 26px; }
      .marketing-cta { padding: 44px 24px; }
      .marketing-cta-title { font-size: 28px; }
      .marketing-footer { padding: 28px 24px; justify-content: center; text-align: center; }
    }

    .marketing-nav-signin:focus-visible, .marketing-faq-item:focus-within {
      outline: 2px solid #F26223; outline-offset: 2px;
    }
""".trimIndent()

val MarketingStyles = FC<Props> {
    style { +marketingStyles }
}
